// src/services/categoryHistoryService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const HISTORY_API_URL = 'category-history/';

// Tipo TypeScript para el historial
export interface CategoryHistory {
    id: number;
    user_email: string;
    user_full_name: string;
    category: string;
    action: 'created' | 'updated' | 'deleted';
    timestamp: string;
    changes: Record<string, { old: any; new: any }> | null;
}

// Obtener todo el historial de categorías
export const fetchCategoryHistory = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<CategoryHistory[]>(HISTORY_API_URL);
        return response.data;
    });
};